import CryptoJS from "crypto-js";

const secretKey = process.env.REACT_APP_PASS;

export function encryptPassword(password) {
    if (!secretKey) {
        console.error("Secret key missing!");
        return "";
    }

    const key = CryptoJS.enc.Utf8.parse(secretKey);

    const encrypted = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(password),
        key,
        {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        }
    );

    return encrypted.toString();
}

export const initializeFilterData = {
    "SearchText": "",
    "StartValue": "2",
    "SearchFieldValue": "",
    "PageSize": "10",
    "AdvanceFilter": []
}